// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-db52a124]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.guide-panel__quick .item[data-v-db52a124]{align-items:center;background-color:hsla(0,0%,100%,.1);border-radius:4px;display:flex;height:32px;justify-content:center;width:32px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
